import { Component } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { NsideIdentityService } from '../../../shared/services/auth/nSideIdentityService';

@Component({
  selector: 'app-no-access',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <div class="min-h-screen w-full flex flex-col items-center justify-center bg-main-background p-8 gap-4">
      <lucide-icon [img]="icons.CircleAlert" [size]="48" class="text-nside-orange-400"></lucide-icon>
      <h1 class="text-2xl oswald-font text-nside-gray-400">Access Denied</h1>
      <p class="text-gray-text text-center max-w-md">
        Your nSide account isn't authorized for the Admin Tools. If you think this is a mistake,
        contact the engineering team.
      </p>
      <button
        type="button"
        (click)="logout()"
        class="bg-blue-500 hover:bg-blue-600 text-white rounded-md px-5 py-2 oswald-font">
        Sign in with a different account
      </button>
    </div>
  `
})
export class NoAccessComponent {
  icons = Icons;
  constructor(private identity: NsideIdentityService) {}
  logout(): void {
    this.identity.logout();
  }
}
